'use strict';

const _ = require('lodash');
const events = require('../events');
const errors = require('../errors');
const utils = require('../utils');
const workerUtils = require('./workerUtils');
const scriptsValidator = require('./scriptsValidator');
const platformUtilities = require('../platformUtilities/platformUtilities');


function setElementoryArguments(args) {
  if (!args.baseUrl || typeof args.baseUrl !== 'string') {
    throw new Error('Load message data must include baseUrl of type string');
  }
  if (!args.queryParameters || typeof args.queryParameters !== 'string') {
    throw new Error('Load message data must include queryParameters of type string');
  }

  if (!self.elementorySupport) {
    self.elementorySupport = {};
  }

  self.elementorySupport.baseUrl = args.baseUrl;
  self.elementorySupport.queryParameters = args.queryParameters;
  self.elementorySupport.options = _.assign({}, self.elementorySupport.options, args.options);
}

function startApplications(apps, routersMap, storageValue, workerId, getApp) {
  return Promise.all(apps.map(function(appDef) {
    var app = getApp(appDef.id);
    app.module.initAppForPage = app.module.initAppForPage || function() { };
    var initAppParam = {
      appInstanceId: appDef.id
    };
    if (appDef.routerData) {
      initAppParam.routerReturnedData = appDef.routerData;
    }
    if (appDef.instance) {
      initAppParam.instance = appDef.instance;
    }
    if (appDef.url) {
      initAppParam.url = appDef.url;
    }
    initAppParam.appRouters = Object.keys(routersMap).map(id => routersMap[id]).filter(routerDef => routerDef.appDefinitionId === appDef.id);


    var appStorage = self.wix.getStorage(appDef.id, storageValue);
    var beforeInit = Date.now();
    try {
      app.ready = Promise.resolve(app.module.initAppForPage(initAppParam, platformUtilities.getApi(routersMap, appStorage)));
    } catch (err) {
      /*eslint-disable no-console*/
      console.error(err);
      app.ready = Promise.reject(new Error(err));
    }
    return app.ready
      .then(function() {
        var afterInit = Date.now();
        workerUtils.reportBI(events.INIT_APP_FOR_PAGE, {
          app_id: appDef.id,
          worker_id: workerId,
          time_spent: afterInit - beforeInit
        });
        return Promise.resolve();
      })
      .catch(function(err) {
        var errorMsg = err && err.message;
        workerUtils.reportBI(errors.INIT_APP_FOR_PAGE, {
          app_id: appDef.id,
          worker_id: workerId,
          error: errorMsg
        });
        /*eslint-disable no-console*/
        console.error(errorMsg);
      });
  }));
}

function updateWixCodeDataAfterLogin(messageData) {
  var elementoryArguments = messageData.elementoryArguments;
  if (elementoryArguments) {
    setElementoryArguments(elementoryArguments);
  }
}

function handleLoad({
  applications,
  routersMap,
  wixCode,
  elementoryArguments,
  lightboxContext,
  sdkParameters,
  storage
}, {workerId, getApp, userCodeStore}) {
  if (!Array.isArray(applications)) {
    throw new Error('Load message data must include applications property of type Array');
  }
  if (!routersMap) {
    throw new Error('Load message data must include routersMap of type object');
  }
  if (wixCode && wixCode[0] && wixCode[0].routerData) {
    self.routerData = wixCode[0].routerData;
  }
  scriptsValidator.validate(wixCode, ['id', 'url', 'scriptName', 'displayName']);

  if (elementoryArguments) {
    setElementoryArguments(elementoryArguments);
  }

  var minimalRoutersMap = _.mapValues(routersMap, function(value) {
    return { prefix: value.prefix, pages: value.pages };
  });
  self.wix.__INTERNAL__.setLightboxContext(lightboxContext);
  self.wix.__INTERNAL__.addEnvParams(_.assign({}, sdkParameters, { routersMap: minimalRoutersMap }));
  self.wix.__INTERNAL__.setContextId(workerId);

  if (wixCode) {
    const modules = userCodeStore.startUserCode(wixCode, storage);
    const mergedUserExports = utils.assign.apply(utils, [{}].concat(modules));
    self.wix.__INTERNAL__.setStaticEventHandlers(mergedUserExports, workerId);

  }

  return startApplications(applications, routersMap, storage, workerId, getApp);
}

module.exports = {
  handleLoad: handleLoad,
  updateWixCodeDataAfterLogin: updateWixCodeDataAfterLogin
};



// WEBPACK FOOTER //
// ./src/main/worker/loadHandler.js